module.exports = __webpack_public_path__ + "static/SFMono-SemiboldItalic-ca70ba8a9030ed9bb7e081f63fd3831b.ttf";